module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxIDEzQzIxLjYgMTMgMjIuMSAxMy4yIDIyLjQgMTMuNkMyMi44IDE0IDIzIDE0LjUgMjMgMTVMMTUgMThMOCAxNlY3SDkuOUwxNy4yIDkuN0MxNy43IDkuOSAxOCAxMC4zIDE4IDEwLjhDMTggMTEuMSAxNy45IDExLjQgMTcuNyAxMS42QzE3LjUgMTEuOCAxNy4yIDEyIDE2LjggMTJIMTRMMTIuMyAxMS4zTDEyIDEyLjJMMTQgMTNIMjFaTTIgN0g2VjE4SDJWN1oiIGZpbGw9IiM1QzVDNUMiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/imgs/provide.svg
// module id = AqP5
// module chunks = 41